import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { IUser, IUserSettings } from "../../interfaces/user.interface";
import { AuthenticationContext } from "../authentication/authentication.provider";
import { IUserContext, IUserProps } from "./user.interface";
import { useGetUserSettings, useUnlockActivityGoals } from "../../hooks/useUser";
import { useGetPEModule, useGetModulesProgress } from "../../hooks/useModules";
import { TranslationContext } from "../translation/translation.provider";
import { DEFAULT_LANGUAGE } from "../../constants";
import { LoadingContext } from "../loading/loading.provider";

const userInitValues = {
    user: undefined,
    userSettings: undefined,
    setUser: Function.prototype(),
    handleUserSettings: Function.prototype()
};

export const UserContext = createContext<IUserContext>(userInitValues);

const UserProvider = ({ children }: IUserProps) => {
    const { lang } = useContext(TranslationContext);
    const { user, setUser } = useContext(AuthenticationContext);
    const [userSettings, setUserSettings] = useState<IUserSettings>();

    const getUserSettings = useGetUserSettings();

    const handleUserSettings = useCallback(async () => {
        const response = await getUserSettings.mutateAsync();

        if (!response.success) return;

        const settings = response.data as IUserSettings;
        setUserSettings(settings);
    }, [user, lang]);

    useEffect(() => {
        if (!user) return;

        handleUserSettings();
    }, [user]);

    return (
        <UserContext.Provider
            value={{
                user,
                setUser,
                userSettings,
                handleUserSettings
            }}>
            {children}
        </UserContext.Provider>
    );
};

export default UserProvider;
